const statusIcons = {
  'captacao_encerrada': {
    value: 'captacao_encerrada',
    label: 'Captação encerrada',
    icon: 'stop_circle',
    color: 'yellow',
  },
  'aprovada': {
    value: 'aprovada',
    label: 'Aprovado',
    icon: 'done',
    color: 'success',
  },
  'execucao': {
    value: 'execucao',
    label: 'Execução',
    icon: 'drafts',
    color: 'success',
  },
  'concluida': {
    value: 'concluida',
    label: 'Aprovado',
    icon: 'done_all',
    color: 'success',
  },
};


export default statusIcons;


// WEBPACK FOOTER //
// ./src/const/project/monitorStatusIcons.js